import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";

const queryClient = new QueryClient();

ReactDOM.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
  document.getElementById('root')
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js');
}

// Auto-reload on deploy via sockethook
{
  function connectWebSocket() {
    const ws = new WebSocket('wss://websocket.ericbetts.dev');

    ws.onopen = () => {
      ws.send(JSON.stringify({
        action: 'subscribe',
        key: '00330579a0ee281f15331946df35efe2c73165293d1b89fcf5479db3763d815b',
      }));

      setInterval(() => {
        if (ws.readyState === WebSocket.OPEN) {
          ws.send(JSON.stringify({
            action: 'echo',
            value: (new Date()).getTime(),
          }));
        }
      }, 5 * 60 * 1000);
    };

    ws.onmessage = (message) => {
      const { data: json } = message;
      const event = JSON.parse(json);
      const { url } = event;
      if (!url) return;
      const project = new URL(url);
      if (project.origin === window.location.origin) {
        window.location.reload();
      }
    };

    ws.onclose = () => {
      setTimeout(connectWebSocket, 5000);
    };
  }

  connectWebSocket();
}
